import Alert from "../../Alert";

import API from "../../Network/API";
import { isLoaded, isLoading, thanksPoints } from "../action";


export async function getThanksPoints(dispatch, getUser) {
  dispatch(isLoading());
  try {
    var response = await API.post("usersAwards.php", {
      "crop": getUser.corp,
      action: 'getThanksPoints',
    }, {}, false);
    // console.log(response)
    if (response.status === 'True') {
      dispatch(thanksPoints(response.data))
    }
    else {
      dispatch(thanksPoints([]))
    }
  } catch (error) {
    Alert('error', error.message);
  }
  dispatch(isLoaded());
}